// src/api/userService.js
import api from "./axiosConfig";

const userService = {
  login(data) {
    return api.post("/auth/login", data);
  },
  getProfile(user) {
    return api.get("/auth/me", user);
  },
  ackDayBrief() {
    return api.post("/auth/day-brief");
  },
  setAppearance(appearance) {
    return api.patch("/auth/appearance", { appearance });
  },
  resetDayBrief() {
    return api.post("/auth/day-brief/reset");
  },
  register(data) {
    return api.post("/auth/register", data);
  },
  previewPrivileges(userId) {
    return api.post(`/auth/preview/${userId}`);
  },

  // Administración
  getAllUsers() {
    return api.get("/users");
  },
  updateUser(id, data) {
    return api.put(`/users/${id}`, data);
  },
  deleteUser(id) {
    return api.delete(`/users/${id}`);
  }
};

export default userService;
